import * as _ from "lodash";
import * as log from "loglevel";
import * as moment from "moment";
import * as React from "react";

import { inject, observer, Provider } from "mobx-react";
import { Dropdown, Pagination, Search } from "semantic-ui-react";
import { QueryString } from "../services/query";
import { AppStore } from "../stores/app-store";
import { AuditStore } from "../stores/audit-store";
import { Audit } from "../stores/models/audit";
import { UserStore } from "../stores/user-store";
import { LoadingSpinner } from "./common/loading-spinner";

interface IAuditViewProps{
	auditStore?: AuditStore;
	appStore?: AppStore;
	userStore?: UserStore;
}

interface IAuditViewState{
	surveyId?: string;
	username?: string;
	appName?: string;
	limit?: number;
	offset?: number;
	errorMessage?: string;
	currentPage?: number;
	selectedAudit?: Audit;
	action?: string;
	searchValues;
	numberOfSibling: number;
}


@inject("auditStore", "appStore", "userStore") @observer
export class AuditView extends React.Component<IAuditViewProps, IAuditViewState>{
	private defaultSearchValues = [
		{"title": "Clearing Respondents"},
		{"title": "Restoring Respondents"},
		{"title": "Quotas Updated"}
	];

	constructor(props, state){
		super(props, state);
		this.state = {"limit": 10, "offset": 0, "currentPage": 1, "searchValues": this.defaultSearchValues, "numberOfSibling": 0};
		this.handleGetAudits = this.handleGetAudits.bind(this);
		this.handleTextChange = this.handleTextChange.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handlePaginationClick = this.handlePaginationClick.bind(this);
	}

	async componentWillMount(){
		await this.props.userStore.loadUsers();
		await this.props.appStore.loadApps();
		this.handleSearchValue("");
	}

	updateNumOfSibling = () => {
		let width = window.innerWidth;
		let num = 0;
		let widthLimit = width - 200 - 40 * 7 - (this.state.currentPage.toString().length * 8 + 32) - (Math.ceil(this.props.auditStore.auditCount / this.state.limit).toString().length * 8 + 32);
		if(widthLimit < 0) {
			num = -1;
		}
		else {
			num = Math.floor(widthLimit / 2 / ((this.state.currentPage.toString().length + 1) * 8 + 32));
		}

		this.setState({"numberOfSibling": num});
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateNumOfSibling);
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.updateNumOfSibling);
	}

	async handleGetAudits(pageNum: number){
		let user = this.props.userStore.findByUsername(this.state.username);
		let app = this.props.appStore.findByName(this.state.appName);
		if(this.state.username && _.isNil(user)){
			this.setState({"errorMessage": `User ${this.state.username} not found`});
		}
		else if(this.state.appName && _.isNil(app)){
			this.setState({"errorMessage": `App ${this.state.appName} not found`});
		}
		else{
			let qs = {
				"surveyId": this.state.surveyId,
				"take": this.state.limit,
				"skip": (pageNum - 1) * this.state.limit,
				"order": {"field": "created", "direction": "desc"}
			};
			if(!_.isNil(this.state.action) && !_.isEmpty(this.state.action)){
				qs["where"] = {"title": this.state.action};
			}
			if(!_.isNil(user)){
				qs["userId"] = user.id;
			}
			if(!_.isNil(app)){
				qs["appId"] = app.id;
			}
			let audits = await this.props.auditStore.loadAudits(new QueryString(qs));
			this.setState({"errorMessage": null, "currentPage": pageNum, "selectedAudit": null});
			this.updateNumOfSibling();
		}
	}

	handleTextChange(name, value){
		this.setState({[name]: value});
	}

	handleRowSelect(audit){
		this.setState({"selectedAudit": audit});
	}

	handlePaginationClick(activePage) {
		let pageNum = 0;
		if(typeof activePage == "string") {
			pageNum = parseInt(activePage);
		}
		else if(typeof activePage == "number") {
			pageNum = activePage;
		}
		this.handleGetAudits(pageNum);
	}

	handleSearchValue(action){
		this.setState({
			"searchValues": _.filter(this.defaultSearchValues, value => { return value.title.toLowerCase().indexOf(action.toLowerCase()) >= 0; })
		});
	}

	render(){

		let pageCount = 0;
		let pages = [];
		if(this.props.auditStore.auditCount > 0){
			pageCount = (this.props.auditStore.auditCount / this.state.limit);
		}


		for(let i = 0; i < pageCount; i++){
			let className = i + 1 === this.state.currentPage ? "active item" : "item";
			if(i > 20){
				pages.push(<a className={className} key={i + 1}>{`...${Math.ceil(pageCount)}`}</a>);
				break;
			}
			else{
				pages.push(<a className={className} onClick={() => this.handleGetAudits(i + 1)}  key={i + 1} >{i + 1}</a>);
			}

		}

		let audits = this.props.auditStore.audits.slice();
		audits = audits.map((audit) => {
			let app = this.props.appStore.findById(audit.appId);
			if(app){
				audit.updateProperty("appName", app.name);
			}
			return audit;
		});

		let dropdownApps = [{"key": 0, "text": "None", "value": "", "icon": ""}];
		if(this.props.appStore.apps){
			this.props.appStore.apps.slice().map( (app, index) => {
				dropdownApps.push({"key": index + 1, "text": app.name, "value": app.name, "icon": app.icon});
			});
		}

		let dropdownUsers = [{"key": 0, "text": "None", "value": ""}];
		if(this.props.userStore.users){
			this.props.userStore.users.slice().map( (user, index) => {
				dropdownUsers.push({"key": index + 1, "text": user.username, "value": user.username});
			});
		}

		return (
			<div style={{"marginTop": "25px", "marginLeft": "100px", "marginRight": "100px"}}>
				{this.props.auditStore.loading &&
					<LoadingSpinner />
				}
				<h1>History</h1>
				<div className="ui form">
					<div className="inline fields">
						<label>Survey ID</label>
						<div className="field">
							<input type="text" value={this.state.surveyId} onChange={(e) => this.handleTextChange("surveyId", e.target.value)} />
						</div>
						<label>Action</label>
						<div className="field">
							<Search value={this.state.action} minCharacters={0} onResultSelect={(e, data) => { this.handleTextChange("action", data.result.title); }} onSearchChange={(e, data) => { this.handleTextChange("action", data.value); this.handleSearchValue(data.value); } } results={this.state.searchValues} icon=""/>
						</div>
						<label>Username</label>
						<div className="field">
							<Dropdown style={{"width": "300px"}} search selection options={dropdownUsers} placeholder="Select User" value={this.state.username} onChange={(e, data) => this.handleTextChange("username", data.value) } />
						</div>
						<label>App Name</label>
						<div className="field">
							<Dropdown search selection options={dropdownApps} placeholder="Select App" value={this.state.appName} onChange={(e, data) => { this.handleTextChange("appName", data.value); }} />
						</div>
						<div className="ui button primary" onClick={() => this.handleGetAudits(1)} >Go</div>
					</div>
				</div>
				{this.state.errorMessage &&
					<div className="ui red icon message">
						<i className="warning sign icon"></i>
						{this.state.errorMessage}
					</div>
				}
				{pages.length > 0 &&
					<div>
						<div className="ui pagination menu">
							{/* {pages} */}
							{
								this.state.numberOfSibling == -1 &&
								<Pagination activePage={this.state.currentPage} siblingRange={1}
								ellipsisItem={null}
								boundaryRange={0}
								totalPages={Math.ceil(pageCount)} onPageChange={(event, {activePage }) => this.handlePaginationClick(activePage)}/>
							}
							{
								this.state.numberOfSibling != -1 &&
								<Pagination activePage={this.state.currentPage} siblingRange={this.state.numberOfSibling} totalPages={Math.ceil(pageCount)} onPageChange={(event, {activePage }) => this.handlePaginationClick(activePage)}/>
							}
						</div>
						<table className="ui celled selectable striped table">
							<thead>
								<tr>
									<th>Action</th>
									<th>Username</th>
									<th>Survey ID</th>
									<th>App Name</th>
									<th>Date</th>
									<th>Type</th>
									<th>Path</th>
								</tr>
							</thead>
							{audits.length > 0 &&
								<tbody>
									{audits.map((audit) => {
										return(
											<tr key={audit.id} onClick={() => this.handleRowSelect(audit)}>
												<td>{audit.title}</td>
												<td>{audit.username}</td>
												<td>{audit.surveyId}</td>
												<td>{audit.appName}</td>
												<td>{moment(audit.created).format("MMMM Do YYYY, h:mm:ss a")}</td>
												<td>{audit.typeName}</td>
												<td>{audit.path}</td>
											</tr>
										);
									})}
								</tbody>
							}
							<tfoot></tfoot>
						</table>
					</div>
				}
				{this.state.selectedAudit &&
					<div className="ui segment">
						<p>{this.state.selectedAudit.content}</p>
					</div>
				}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/views/audit-view.tsx